import { extendTheme, type ThemeConfig } from "@chakra-ui/react";

const config: ThemeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

export const theme = extendTheme({
  config,
  fonts: {
    heading:
      '"Space Grotesk", "Instrument Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    body: '"Instrument Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    accent: '"Instrument Serif", "Instrument Sans", Georgia, serif',
    mono: '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
  },
  styles: {
    global: {
      html: {
        scrollBehavior: "smooth",
      },
      body: {
        bg: "chakra-body-bg",
        color: "chakra-body-text",
      },
      "::selection": {
        background: "rgba(232,164,74,0.35)",
      },
    },
  },
  colors: {
    graphite: {
      50: "#f6f6f7",
      100: "#eaeaec",
      200: "#d5d5d9",
      300: "#b0b1b8",
      400: "#858792",
      500: "#696b76",
      600: "#54555f",
      700: "#45454e",
      800: "#3c3c44",
      900: "#282830",
      950: "#141419",
    },
    accent: {
      50: "#fdf8f1",
      100: "#faecd8",
      200: "#f3d5a8",
      300: "#ecb972",
      400: "#e8a44a",
      500: "#e0862c",
      600: "#c06a1d",
      700: "#98531a",
      800: "#7a441b",
      900: "#63391a",
    },
    violet: {
      50: "#f6f4fe",
      100: "#ece6fd",
      200: "#d5c8fa",
      300: "#b6a0f5",
      400: "#9575ef",
      500: "#7c56e8",
      600: "#6a3fd4",
      700: "#5731ab",
      800: "#48298a",
      900: "#3a2270",
    },
  },
  semanticTokens: {
    colors: {
      "chakra-body-bg": {
        default: "graphite.50",
        _dark: "graphite.950",
      },
      "chakra-body-text": {
        default: "graphite.900",
        _dark: "graphite.100",
      },
      "chakra-border-color": {
        default: "blackAlpha.200",
        _dark: "whiteAlpha.100",
      },
    },
  },
  components: {
    Button: {
      baseStyle: { fontWeight: "600" },
      variants: {
        solid: ({ colorScheme }: { colorScheme: string }) =>
          colorScheme === "accent"
            ? {
                bg: "accent.400",
                color: "graphite.950",
                _hover: { bg: "accent.300" },
                _active: { bg: "accent.500" },
              }
            : {},
      },
    },
    Link: {
      baseStyle: { _focusVisible: { boxShadow: "outline" } },
    },
  },
});
